import * as t from './actionTypes';

const initialState = {
  campaignAnalytics: [],
  isLoading: true,
  campaign: {},
  selectedVariant: {},
  campaignMetrics: {},
  allDestinations: [],
};

const campaignAnalyticsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case t.FETCH_STATS_FOR_TIMERANGE_RESPONSE: {
      return {
        ...state,
        statsForTimeRange: action.response,
        isLoading: false,
      };
    }
    case t.FETCH_STATS_FOR_TIMERANGE_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.FETCH_STATS_FOR_TIMERANGE_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case t.FETCH_METRICS_FOR_CAMPAIGN_RESPONSE: {
      return {
        ...state,
        campaignMetrics: action.response,
      };
    }
    case t.FETCH_CAMPAIGN_LINK_STATS_RESPONSE: {
      return {
        ...state,
        campaignLinkStats: action.response,
        isLoading: false,
      };
    }
    case t.FETCH_CAMPAIGN_LINK_STATS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.FETCH_CAMPAIGN_LINK_STATS_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case t.UPDATE_CAMPAIGN_DATA: {
      return {
        ...state,
        campaign: action.campaign,
      };
    }
    case t.UPDATE_SELECTED_VARIANT: {
      return {
        ...state,
        selectedVariant: action.variant,
      };
    }
    case t.UPDATE_ANALYTICS_METRICS_OPTIONS: {
      return {
        ...state,
        analyticsMetricsOptions: action.options,
      };
    }
    case t.FETCH_DESTINATIONS_RESPONSE: {
      return {
        ...state,
        allDestinations: action.response,
      };
    }
    default: {
      return state;
    }
  }
};

export default campaignAnalyticsReducer;
